import React, { FC } from 'react';
import { Group } from '@mantine/core';
import { TabletFilterLabel } from './TabletFilterLabel';
import { TabletFilterInput } from './TabletFilterInput';
import { ReactComponent as IconMinus } from '../img/iconMinus.svg';

export interface FilterAmountRangeProps {
  fromValue: string | number;
  toValue: string | number;
  onFromChange: (value: string | number) => void;
  onToChange: (value: string | number) => void;
  fromPlaceholder?: string;
  toPlaceholder?: string;
  label?: string;
  className?: string;
  show?: boolean;
  hideSearchIcon?: boolean;
}

export const TabletFilterAmountRange: FC<FilterAmountRangeProps> = ({
  fromValue,
  toValue,
  onFromChange,
  onToChange,
  fromPlaceholder = '03',
  toPlaceholder = '1 000 000',
  label,
  className,
  show,
  hideSearchIcon = false,
}) => {
  return (
    <div className={className}>
      {label && <TabletFilterLabel>{label}</TabletFilterLabel>}
      <Group gap='8px' align='flex-end' bg='#F1F4F9'>
        <div style={{ flex: 1 }}>
          <TabletFilterInput
            type='number'
            value={fromValue}
            onChange={onFromChange}
            placeholder={fromPlaceholder}
            min={0}
            label={'От'}
            show={show}
            hideSearchIcon={hideSearchIcon}
          />
        </div>
        <div
          style={{
            flexShrink: 0,
            height: 48,
            display: 'flex',
            alignItems: 'center',
          }}>
          <IconMinus />
        </div>
        <div style={{ flex: 1 }}>
          <TabletFilterInput
            type='number'
            value={toValue}
            onChange={onToChange}
            placeholder={toPlaceholder}
            min={0}
            label={'До'}
            show={show}
            hideSearchIcon={hideSearchIcon}
          />
        </div>
      </Group>
    </div>
  );
};
